import { Component, EventEmitter, Input, OnInit, Output, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: 'app-editar-titular',
  standalone: true,
  imports: [DialogModule, ConfirmDialogModule, DropdownModule, FormsModule],
  templateUrl: './editar-titular.component.html',
  styleUrl: './editar-titular.component.scss'
})
export class EditarTitularComponent{
    @Input() visible: boolean=false;
    @Input() titulares: {nombreCompleto: string, uniqueId: string}[] = [];
    @Input() titularPreSeleccionado: string = "";
    titularSeleccionado: string = this.titularPreSeleccionado;
    @Output() onClose = new EventEmitter<void>();
    @Output() onConfirmSubmit = new EventEmitter<string>();
    disabled = signal(true);

    onCloseDialog() {
        this.visible = false;
        this.disabled.set(true);
        this.onClose.emit();
    }

    onConfirmSubmitDialog() {
        this.onConfirmSubmit.emit(this.titularSeleccionado);
        this.disabled.set(true);
    }

    onTitularChange(selectedUniqueId: string) {
        this.disabled.set(selectedUniqueId !== this.titularPreSeleccionado ? false : true);
        this.titularSeleccionado = this.titulares.find(t => t.uniqueId === selectedUniqueId)?.uniqueId ?? "";
    }
}
